import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import SearchPopover_vue_vue_type_script_setup_true_lang_default from "./SearchPopover.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                  */
//#region src/components/SearchPopover.vue
var SearchPopover_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SearchPopover_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-3e0405c7"]]);
//#endregion
export { SearchPopover_default as default };

//# sourceMappingURL=SearchPopover.vue.js.map